import { fetchNextAvailableDates } from './fetchNextAvailableDates';
import { GlobalReactQueryOptions } from '../../config';
import { useQuery } from '@tanstack/react-query';

const NEXT_AVAILABLE_DATE_KEY = `nextAvailableDates`;

export const useNextAvailableDates = ({ productId }: { productId: string }) => {
    return useQuery([NEXT_AVAILABLE_DATE_KEY, productId], () => fetchNextAvailableDates(productId), {
        ...GlobalReactQueryOptions,
        staleTime: 5 * 60 * 1000
    });
};
